var _style, _g, _rect, _path, _path2, _polygon, _path3, _polygon2, _path4, _path5, _polygon3, _path6, _polygon4, _polygon5, _polygon6, _polyline, _polyline2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLdbxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 945.1 651",
    style: {
      enableBackground: "new 0 0 945.1 651"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#20F7F7;}\r\n\t.st1{opacity:0.2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 577.6,
    y: 337.6,
    width: 58.6,
    height: 24.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569.2,376.5c0,22.3-20.4,40.4-45.5,40.4c-0.1,0-105.2,0-105.2,0V283.1h99.7c25.1,0,45.5,18.1,45.5,40.4 c0,8.9-3.2,17.1-8.7,23.7C563.7,354.6,569.2,365,569.2,376.5z M449.9,336.1c0,0,66.2,0,70.1,0c7-0.8,12.3-6.1,12.3-12.6 c0-7-6.4-12.7-14.2-12.7h-68.2V336.1z M537.7,376.5c0-7-6.4-12.7-14.2-12.7h-73.6v25.4h73.6C531.4,389.2,537.7,383.5,537.7,376.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.9,283.1h-75.3v96.7H315V311h43.9c24.2,0,43.9,17.5,43.9,39c0,21.5-19.7,39-43.9,39h-28.4v0.1H209v-106h-31.4V417h166.7 v-0.1c8.5,0,14.5,0,14.6,0c41.6,0,75.3-30,75.3-66.9C434.2,313,400.5,283.1,358.9,283.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "670,346 587.5,422.8 587.5,426.1 599.3,426.6 676.3,352.6 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M694.9,372.1l-12.3-12.8l-69.2,68.1l18.7,0.9C634.1,427.5,694.9,372.1,694.9,372.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "676.3,352.6 670,346 665.3,350.4 671.9,356.9 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M682.7,359.3l-4.1,4l12.6,12.2c0.7-0.6,1.3-1.2,1.8-1.6l1.9-1.7L682.7,359.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M765.3,267.2c-1.9,0.8-62.7,56.1-62.7,56.1l12,12.6l69.6-67.8L765.3,267.2z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "813.2,269.5 803,269 721,342.7 727.5,349.4 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.3,319.9c-0.7,0.6-1.3,1.2-1.8,1.6l-2,1.8l12,12.5l4.3-3.9L706.3,319.9z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "732.2,345 725.6,338.5 721,342.7 727.5,349.4 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "814.6,261.4 813.1,270.7 811.6,279.9 804.3,274 797,268.1 805.8,264.7 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "584.4,434.8 585.8,425.6 587.3,416.3 594.6,422.2 601.9,428.1 593.1,431.5 "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "696.1,324.2 652.8,284.8 604.9,284.8 694.9,372.1 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "701.4,371.3 744.6,410.6 792.6,410.6 702.5,323.3 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdbxLogo);
export default __webpack_public_path__ + "static/media/ldbx_logo.4bf31ffc5298ed4cc21550afd675ba37.svg";
export { ForwardRef as ReactComponent };